import {Box, Button, Flex, P, showMessage} from 'exsportia-components'
import React, {FC} from 'react'

import {ExsportiaIcon} from '../../../ui/components/exsportia-icon/exsportia-icon'
import {firebaseOptions} from '../../../utils/environment'
import {useLocale} from '../../../utils/i18n'

type Props = {
  address: {
    addressDetails: string
    latLng: {
      lat: number
      lng: number
    }
  }
}

export const LocationSection: FC<Props> = ({address}) => {
  const {l} = useLocale()

  const handleOpenMap = () => {
    const {lat, lng} = address.latLng
    window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank')
  }

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(address.addressDetails).then(() => {
      showMessage(l('referenceNumberCopied'), 'success')
    }).catch(e => console.log(e))
  }

  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${address.latLng.lat},${address.latLng.lng}&zoom=15&size=600x300&markers=color:red%7C${address.latLng.lat},${address.latLng.lng}&key=${firebaseOptions.API_KEY}`

  return (
    <Box>
      <Box
        mt='12px'
        position='relative'
        borderRadius='16px'
        overflow='hidden'
        height='180px'
        settings={{
          bg: 'primary-10',
          border: '1px solid',
          borderColor: 'primary-20'
        }}
      >
        <Box
          as='img'
          // @ts-ignore
          src={mapUrl}
          width='100%'
          height='100%'
          style={{objectFit: 'cover'}}
        />
        <Box
          position='absolute'
          top='0'
          left='0'
          width='100%'
          height='100%'
          settings={{
            bg: 'rgba(0,0,0,0.05)'
          }}
        />

        <Box
          position='absolute'
          bottom='20px'
          left='50%'
          style={{transform: 'translateX(-50%)', width: '80%'}}
        >
          <Button
            settings={{width: '100%', height: '48px', borderRadius: '24px'}}
            onClick={handleOpenMap}
          >
            {l('openMap', {caseAction: 'capitalize'})}
          </Button>
        </Box>
      </Box>
      <Flex
        mt='16px'
        alignItems='center'
        justifyContent='space-between'
        onClick={handleCopyAddress}
        cursor='pointer'
      >
        <P fontSize='body' color='text-secondary'>{address.addressDetails}</P>
        <ExsportiaIcon icon='copy' w={20} h={20} color='text-secondary' />
      </Flex>
    </Box>
  )
}
